import AdminPlanningReviewsActionPanel from './admin-planning-reviews-action-panel'

export default AdminPlanningReviewsActionPanel
